import {
  FETCH_SMOKING_LOGS_REQUEST,
  FETCH_SMOKING_LOGS_SUCCESS,
  FETCH_SMOKING_LOGS_FAILURE,
} from "../constants";

const initialState = {
  data: [],
  loading: false,
  error: null,
};

const getAllSmokingLogsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_SMOKING_LOGS_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_SMOKING_LOGS_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
      };
    case FETCH_SMOKING_LOGS_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default getAllSmokingLogsReducer;
